import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { Countries } from 'projects/zbs-app/src/app/services/Ebootis.Queries/Countries';
import { Observable } from 'rxjs';
import { CountrySelectService } from './country-select.service';

@Component({
	selector: 'app-country-select',
	templateUrl: './country-select.component.html',
	styleUrls: ['./country-select.component.scss']
})
export class CountrySelectComponent {

	@Input() public countryCtrl: UntypedFormControl;
	@Input() public readonly: boolean = false;
	@Input() public required: boolean = false;

	@Output() public countrySelected: EventEmitter<string> = new EventEmitter();

	public m_countries$: Observable<Countries.Result[]> = this.m_countrySelectService.getCountries();

	constructor(
		private m_countrySelectService: CountrySelectService
	) { }

	/**
	 * Bei einer Änderung des Country wird der Inhalt des Controls an das aufrufende Component übergeben.
	 * @param event ChangeEvent
	 */
	public changedCountry(event): void {
		this.countrySelected.emit(this.getControl().value);
	}

	/**
	 * Gibt das FormControl des Country zurück.
	 */
	public getControl(): AbstractControl {
		return this.countryCtrl;
	}

	/**
	 * Prüft ob das aktuelle FormControl ein Pflichtfeld ist.
	 */
	public isRequiredField(): boolean {
		const form_field = this.getControl();
		if (!form_field.validator) {
			return false;
		}

		const validator = form_field.validator({} as AbstractControl);
		return (validator && validator.required);
	}

}
